import React, { Component } from "react";
import { connect } from "react-redux";
import { requestCheckAuthorized } from "../actions/authenticationActions.js";
import { authenticate } from "../actions/authenticationRequests.js";
import Header from "../../common/components/Header";
import { MAIN_CONTENT, MAIN_SECTION } from "../../styles";

const errorColor = "rgb(217, 83, 79)";

const passwordInputStyle = {marginTop: ".5em"};
const loginSectionHeaderStyle = {
    backgroundColor: "none",
    borderBottom: 0,
    padding: 0,
    marginBottom: "0.5em",
    color: "#777"
};
const inputStyle = {marginTop: ".5em", width: "100%"};
const buttonStyle = {margin: ".5em 0", width: "100%"};
const secondaryTextColor = "#aaa";
const orSeparatorStyle = {
    verticalAlign: "top",
    display: "inline-block",
    height: "100%",
    margin: "0 5em",
    padding: "1em 0",
    width: 0,
    borderLeft: "1px solid #ddd"
};
const orStyle = {
    position: "relative",
    top: "45%",
    left: "-0.5em",
    width: "20px",
    padding: "0.3em 0",
    backgroundColor: "white",
    color: secondaryTextColor,
    fontWeight: "bold"
};
const welcomeMessageStyle = {
    fontSize: "20pt",
    color: secondaryTextColor,
    margin: "2em 0"
};
const linkStyle = {
    color: "#0078e7"
};

function passwordResetUri() {
    if (typeof RECORDER_CONFIG === 'undefined') {
        return "no-server-provided-config-assuming-javascript-testing";
    }
    return RECORDER_CONFIG.passwordResetUri;
}

export class SignIn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            failedAuthentication: false,
            loginInProgress: false
        };
        this._handleSubmit = this._handleSubmit.bind(this);
        this._onSuccess = this._onSuccess.bind(this);
        this._onError = this._onError.bind(this);
    }

    render() {
        let errorMessage;

        if (this.state.failedAuthentication) {
            errorMessage = <div style={{color: errorColor}}>The username and password you entered don't match.</div>;
            passwordInputStyle.borderColor = errorColor;
        }

        let multiLoginForm = <div style={{width: 870, padding: ".5em", height: 195, margin: "0 auto"}}>
            <div style={welcomeMessageStyle}>Welcome! What do you want to do?</div>
            <div style={Object.assign({}, MAIN_SECTION, {width: 375, height: "100%", padding: "1em", display: "inline-block"})}>
                <Header style={loginSectionHeaderStyle}>Record investment recommendations you make</Header>
                <form id="signInForm" className="pure-form" onSubmit={this._handleSubmit}>
                    <input ref="username" type="text" placeholder="Username" autoComplete="off" autoCapitalize="off" autoCorrect="off" spellCheck={false}
                           className="x-username-input" style={inputStyle}/>
                    <input ref="password" type="password" placeholder="Password"
                           className="x-password-input" style={inputStyle}/>
                    { errorMessage }
                    <button type="submit" className="x-login-submit-button pure-button pure-button-primary"
                            style={buttonStyle} disabled={this.state.loginInProgress}>
                        {this.state.loginInProgress ? "Signing in..." : "Sign in"}
                    </button>
                </form>
                <div style={{marginTop: "0.5em", textAlign: "right"}}>
                    <a style={linkStyle} href={passwordResetUri()}>Forgot your password?</a>
                </div>
            </div>
            <div style={orSeparatorStyle}>
                <div style={{height: "100%"}}>
                    <div style={orStyle}>or</div>
                </div>
            </div>
            <div style={Object.assign({}, MAIN_SECTION, {width: 265, height: "100%", padding: "1em", display: "inline-block", verticalAlign: "top"})}>
                <div style={{position: "relative", top: "30%"}}>
                    <Header style={loginSectionHeaderStyle}>View disclosures you've been sent</Header>
                    <a className="pure-button pure-button-primary" style={buttonStyle} href="#/verify-email">
                        Access the disclosure portal
                    </a>
                </div>
            </div>
        </div>;

        return multiLoginForm;
    }

    _handleSubmit(event) {
        event.preventDefault();

        this.setState({loginInProgress: true});

        authenticate(this.refs.username.value, this.refs.password.value, this._onSuccess, this._onError);
    }

    _onSuccess() {
        const { location } = this.props;

        this.setState({loginInProgress: false});

        if (location.state && location.state.nextPathname) {
            this.context.router.push(location.state.nextPathname);
        } else {
            this.context.router.push("/");
        }
        this.props.checkAuthorized();
    }

    _onError() {
        this.setState({ failedAuthentication: true, loginInProgress: false });
    }
}

SignIn.contextTypes = {
    router: React.PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    checkAuthorized: () => dispatch(requestCheckAuthorized())
});

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);


/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/components/SignIn.js
 **/